function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#252C32"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M27.79 22.232c3.07 0 5.558 2.489 5.558 5.558v5.558h-2.223V27.79c0-1.842-1.493-3.335-3.335-3.335H16.674c-1.842 0-3.335 1.493-3.335 3.335v5.558h-2.223V27.79c0-3.07 2.488-5.558 5.558-5.558zm-5.558-12.228c3.07 0 5.558 2.489 5.558 5.559 0 3.07-2.488 5.558-5.558 5.558s-5.558-2.489-5.558-5.558c0-3.07 2.489-5.559 5.558-5.559zm-7.781 2.224v2.223H6.67c-1.228 0-2.224.995-2.224 2.223v4.447H2.223v-4.447c0-2.456 1.99-4.446 4.447-4.446h7.78zm7.781 0c-1.842 0-3.335 1.493-3.335 3.335 0 1.841 1.493 3.334 3.335 3.334 1.842 0 3.335-1.493 3.335-3.334 0-1.842-1.493-3.335-3.335-3.335zM9.938 2.223c2.455 0 4.446 1.99 4.446 4.447 0 2.455-1.99 4.446-4.446 4.446-2.456 0-4.447-1.99-4.447-4.446 0-2.456 1.991-4.447 4.447-4.447zm0 2.223c-1.228 0-2.223.996-2.223 2.224 0 1.227.995 2.223 2.223 2.223 1.228 0 2.223-.996 2.223-2.223 0-1.228-.995-2.224-2.223-2.224z",
  transform: "translate(-261 -1846) translate(261.714 1846)"
}))));

var SvgUsers = function SvgUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/users.81aaefe3.svg";
export { ForwardRef as ReactComponent };